import Logo from '../components/Logo';

document.querySelectorAll('.animated-logo').forEach(el => new Logo(el));
